export enum ClosingUnit {
  Hours = 'h',
  Minutes = 'm',
}
